import React from 'react';

const ExpandLeftSvg = (props) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            fill="#010101"
            d="M22 2v10h-1V3.7L3.7 21H12v1H2V12h1v8.3L20.3 3H12V2z"
        />
    </svg>
);

ExpandLeftSvg.displayName = 'ExpandLeftSvg';
export default ExpandLeftSvg;
